import { createSlice } from "@reduxjs/toolkit";
import { roomsApi } from "../roomsServices";
import { RootState } from "../../app/store";

type RoomsSlice = {
	rooms: [] | null;
	searchRooms: string,
	favRooms: string,
};

const roomsSlice = createSlice({
	name: "rooms",
	initialState: { rooms: [], searchRooms: "" } as RoomsSlice,
	reducers: {
		logout(state) {
			state.rooms = null;
		},
		searchRoom(state, { payload }) {
			state.searchRooms = payload
		},
		favRoom(state, { payload }) {

			state.favRooms = payload
			localStorage.setItem("roomMessage", payload);
		}
	},

	extraReducers: (builder) => {
		builder.addMatcher(
			roomsApi.endpoints.getRooms.matchFulfilled,
			(state, { payload }) => {
				state.rooms = payload.data
			}
		);
		builder.addMatcher(
			roomsApi.endpoints.getFavRooms.matchFulfilled,
			(state, { payload }) => {

				state.rooms = payload.data


			}
		);
	},




});
export const roomsListArray = (state: RootState) => state.rooms.rooms
export const searchRooms = (state: RootState) => state.rooms.searchRooms
export const favRooms = (state: RootState) => state.rooms.favRooms

export const roomStates = (state: RootState) => state.rooms
export const { logout, searchRoom, favRoom } = roomsSlice.actions;
export default roomsSlice.reducer;
